export enum CmsButtonIcon {
  add = 'add',
  close = 'close',
  keyboard_arrow_right = 'keyboard_arrow_right',
  save = 'save',
  restart_alt = 'restart_alt',
  notifications = 'notifications',
  search = 'search',
  equalizer = 'equalizer',
  star = 'star'
}

export const CMS_BUTTON_ICONS: Record<CmsButtonIcon, string> = {
  [CmsButtonIcon.add]: 'Add',
  [CmsButtonIcon.close]: 'Close',
  [CmsButtonIcon.keyboard_arrow_right]: 'Arrow',
  [CmsButtonIcon.save]: 'Save',
  [CmsButtonIcon.restart_alt]: 'Reset',
  [CmsButtonIcon.search]: 'Search',
  [CmsButtonIcon.equalizer]: 'Simulate',
  [CmsButtonIcon.star]: 'Star',
  [CmsButtonIcon.notifications]: 'Notification'
};
